import { render, staticRenderFns } from "./cdch.vue?vue&type=template&id=7fec2b51&scoped=true&"
import script from "./cdch.vue?vue&type=script&lang=js&"
export * from "./cdch.vue?vue&type=script&lang=js&"
import style0 from "./cdch.vue?vue&type=style&index=0&id=7fec2b51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fec2b51",
  null
  
)

export default component.exports